import { Component, inject } from '@angular/core';

import { DerivedAuthService } from '@shared/lib/services/derived-auth.service';
import { CloudService, IconComponent } from '@shared/public-api';
import { environment } from 'projects/portal/src/environments/environment';

@Component({
  selector: 'wu-qualtricks',
  imports: [IconComponent],
  templateUrl: './qualtricks.component.html',

  styleUrl: './qualtricks.component.scss',
})
export class QualtricksComponent {
  private readonly derivedAuthService = inject(DerivedAuthService);
  private readonly cloudService = inject(CloudService);

  readonly studentId = this.derivedAuthService.studentId();

  public bigQueryParam = {
    studentParam: 'STUDENT',
    afterExecutionParam: 'AFTER EXECUTION',
    LogType: 'INFO',
  };

  goToQualtricks() {
    const bannerStudentId = window.btoa(
      JSON.stringify({ studentid: this.studentId }),
    );
    const desc = `Qualtricks : ${this.derivedAuthService?.currentUser()?.displayName} - ${bannerStudentId} : Clicked qualtricks feedback button`;
    this.auditLog(
      this.bigQueryParam.LogType,
      this.derivedAuthService.currentUser()?.email?.toLowerCase(),
      this.derivedAuthService.currentUser()?.uid,
      this.bigQueryParam.studentParam,
      'goToQualtricks',
      this.bigQueryParam.afterExecutionParam,
      'Qualtricks feedback clicked',
      desc,
      'LOG INFO FOR GO TO QUALTRICKS FEEDBACK',
      'goToQualtricks : Feedback button clicked',
    );
    window.open(
      `${environment.qualtricksUrl}?Q_EED=${bannerStudentId}`,
      '_blank',
    );
  }

  // private addtoStack(id, action, logType, description) {
  //   const messageBody = description;
  //   const stackData = {
  //     email: id,
  //     activity: action,
  //     logType: logType,
  //     description: messageBody
  //   }
  //   this.cloudService.postDataToStack(stackData, response => {
  //     // Response callback
  //   },
  //     error => {
  //       console.error(error);
  //     });
  // }

  auditLog(
    logType: string,
    emailData: any,
    userIdData: any,
    userTypeData: string,
    eventName: string,
    activityStatusData: string,
    operationalStatus: string,
    payLoadData: string,
    comments: string,
    eventTypeData: string,
  ) {
    const auditData = {
      logType: logType,
      email: emailData,
      userId: userIdData,
      bannerId: this.studentId?.split('.')[1],
      userType: userTypeData,
      eventName: eventName,
      activityStatus: activityStatusData,
      operationalStatus: operationalStatus,
      payLoad: payLoadData,
      comments: comments,
      createdBy: 'Portal Refresh',
      eventType: eventTypeData,
    };
    const baseUrlDetails = environment.cloudFunction.baseUrl;
    this.cloudService.postDataToBigQuery(
      baseUrlDetails,
      auditData,
      (response: any) => {
        // Handle success response
      },
      (error: any) => {
        console.error(error);
      },
    );
  }
}
